<template>
  <div>
    <div v-for="(schema, index) in schemas" :key="key(schema, index)">
      <schema-form :schema="schema" v-model="form" />
    </div>

    <div class="columns">
      <div class="column"></div>
      <div class="column is-narrow">
        <b-button @click="onFilterAccept" type="is-info" size="is-medium">Actualizar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import SchemaForm from '@/components/SchemaForm'
import { debounce } from 'lodash-es'

import { retrieveUrl, retrieveRelevantForm } from '@/schema/helpers'

export default {
  name: 'FilterSet',
  components: {
    SchemaForm
  },
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {},
      debouncedOnFilterAccept: debounce(this.onFilterAccept, 100)
    }
  },
  computed: {
    schemas() {
      if (typeof this.schema.allOf === 'undefined') {
        return [this.schema]
      }

      return this.schema.allOf
    }
  },
  methods: {
    key(schema, index) {
      return `${schema.title}-${index}`
    },
    onFilterAccept() {
      let metabaseRequest = retrieveRelevantForm(this.schema, this.form)

      if (Object.keys(metabaseRequest).length > 0) {
        this.$emit('filter-changed', {
          url: retrieveUrl(this.schema, this.form),
          params: metabaseRequest
        })
      }
    }
  },
  updated() {
    this.debouncedOnFilterAccept()
  }
}
</script>
